import cn from 'bem-cn';

import { List, Stack } from '../../../UI';

import { ChallengePrize, ChallengePrizeType } from './ChallengePrize';
import { CHALLENGE_PRIZES } from './ChallengePrizes.constants';
import './ChallengePrizes.scss';

const b = cn('challenge-prizes');

const renderPrize = (item: ChallengePrizeType) => <ChallengePrize {...item} />;
const extractTagKey = (_: ChallengePrizeType, index: number) => `prize-${index}`;

export const ChallengePrizes = () => {
    return (
        <Stack spacing={16} className={b()}>
            <h2 className={b('title')}>Призы для победителей</h2>
            <List
                direction="row"
                className={b('list')}
                items={CHALLENGE_PRIZES}
                renderItem={renderPrize}
                keyExtractor={extractTagKey}
            />
        </Stack>
    );
};
